import React from 'react';
import { ArrowDownIcon, BookOpenIcon, PrinterIcon, RulerIcon, StoreIcon } from 'lucide-react';
import { PREVIEW_ANCHOR } from '../../data/collection';
import { secondaryLinkClass } from '../../utils/buttonStyles';
const BENEFITS = [{
  icon: PrinterIcon,
  title: 'Moldes listos para imprimir',
  text: 'No tenés que diseñar ni dibujar tus propios patrones. Elegí el modelo, imprimí los moldes en A4 y prepará las piezas para empezar a confeccionar.'
}, {
  icon: BookOpenIcon,
  title: 'Ideal para principiantes',
  text: 'Cada modelo incluye su manual de confección con instrucciones paso a paso, desde la preparación y el corte hasta el armado y las terminaciones.'
}, {
  icon: StoreIcon,
  title: 'Empezá tu propio emprendimiento',
  text: 'Tené una colección de 31 modelos infantiles para confeccionar tus primeras prendas y comenzar a armar tu catálogo de productos.'
}, {
  icon: RulerIcon,
  title: '10 talles para ofrecer más opciones',
  text: 'Cada modelo incluye moldes Multi-talle por estatura, desde 50 hasta 104 cm, para que puedas confeccionar distintas medidas.'
}];

/** The two motivations the collection serves. */
const AUDIENCES = [{
  label: 'Si estás empezando',
  text: 'Empezá a crear tus primeras prendas infantiles con moldes listos para imprimir y manuales que te acompañan paso a paso.'
}, {
  label: 'Si ya tenés tu emprendimiento',
  text: 'Ampliá tu catálogo con 31 modelos infantiles y ofrecé más variedad de prendas y talles a tus clientas, sin tener que desarrollar cada molde desde cero.'
}];

/** Four short benefits + the two audiences, no price. */
export function BenefitsSection() {
  return <section aria-labelledby="beneficios-title" className="w-full bg-ivory" data-id="element-159" data-mp="t7kz4g3kah8b">
      <div className="mx-auto max-w-6xl px-5 py-12 sm:px-8 lg:py-16" data-id="element-160" data-mp="ebdfphzz9ju3">
        <h2 id="beneficios-title" className="sr-only" data-id="element-161" data-mp="ed6nj0mbua3o">
          Qué incluye la colección
        </h2>
        <ul className="grid grid-cols-1 gap-x-10 divide-y divide-dashed divide-coral/35 md:grid-cols-2 md:gap-y-10 md:divide-y-0 lg:grid-cols-4 lg:gap-x-8 [&>*]:min-w-0" data-id="element-162" data-mp="jcatzjhv9tqb">
          {BENEFITS.map(({
          icon: Icon,
          title,
          text
        }) => <li key={title} className="flex gap-4 py-5 first:pt-0 last:pb-0 md:flex-col md:gap-3 md:py-0" data-id="element-163" data-mp="3mkmr3u5uu74x">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-blush text-coral-ink" data-id="element-164" data-mp="3hml633ovbxqt">
                <Icon className="h-5 w-5" aria-hidden data-id="element-165" data-mp="j34l7s9n7a75" />
              </span>
              <div className="min-w-0" data-id="element-166" data-mp="e531r68b18v5">
                <h3 className="font-serif text-[1.3rem] font-semibold leading-tight text-graphite sm:text-[1.45rem]" data-id="element-167" data-mp="e64ctapblvcv">{title}</h3>
                <p className="mt-1.5 text-[1rem] leading-relaxed text-graphite-soft" data-id="element-168" data-mp="476tcm6r4s0q">{text}</p>
              </div>
            </li>)}
        </ul>

        <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6 [&>*]:min-w-0" data-id="element-169" data-mp="2txa6vqn62bes">
          {AUDIENCES.map(audience => <div key={audience.label} className="rounded-[16px] bg-blush px-5 py-4 sm:px-6 sm:py-5" data-id="element-170" data-mp="2ozqpwiz33kj5">
              <p className="text-[0.95rem] font-extrabold text-coral-ink" data-id="element-171" data-mp="14dioe6yu56ym">{audience.label}</p>
              <p className="mt-1.5 text-[1rem] leading-relaxed text-graphite" data-id="element-172" data-mp="19c3lhxisjaiu">{audience.text}</p>
            </div>)}
        </div>

        <div className="mt-8 flex justify-center md:mt-10" data-id="element-173" data-mp="1j4j3uvy02149">
          <a href={PREVIEW_ANCHOR} className={secondaryLinkClass} data-id="element-174" data-mp="1j62oszulp0cd">
            Mirá cómo viene por dentro
            <ArrowDownIcon className="h-4 w-4 shrink-0" aria-hidden data-id="element-175" data-mp="1s4xqbymp9m9c" />
          </a>
        </div>
      </div>
    </section>;
}